
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import NotFound from './NotFound.vue'

/**
 * This component created to fix nuxtjs bug during render 404 page on server side
 * Detail about task: https://zaproo.atlassian.net/browse/ZBP-34
 * Issue: https://github.com/nuxt/nuxt.js/issues/7285
 * Please wrap all routes with dynamic paths with it,
 * to correctly display the 404 page on the client and server sides,
 * as well as to prevent problems with guides
 */
export default defineComponent({
  name: 'NotFoundPageWrapper',
  components: {
    NotFound
  },
  props: {
    hasNotFound: {
      type: Boolean as PropType<boolean>,
      required: true
    }
  }
})
